export default __webpack_public_path__ + "static/media/main_nl.a2fb8c76.jpg";